module.exports = __webpack_public_path__ + "img/qingyang3.e0b27569.png";